import RichTextPage from './RichTextPage';

export default RichTextPage;
